<template>
  <div class="car_rent_order">
    <div class="car_rent_order_nav">
      <navbar
        title="订单详情"
        :lefticon="lefticon"
        :lefticonheight="2.4"
        :lefticonwidth="2.4"
        :fontweight="700"
        :fontsize="'1.7rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
      <div class="box">
        <van-row class="goods">
          <van-col span="24" class="goods_info">
            <img
              v-if="
                detailInfo.car_order_goods && detailInfo.car_order_goods.images
              "
              :src="detailInfo.car_order_goods.images[0]"
            />
            <div class="goods_r" v-if="detailInfo.car_order_goods">
              <p class="name">
                {{ detailInfo.car_order_goods.goods_name }}
              </p>
              <p class="stock">
                <span
                  >所选颜色：{{
                    detailInfo.car_order_goods.specification_name
                  }}</span
                >
              </p>
              <p class="unit_price">
                <span class="label_">￥</span>{{ detailInfo.daily_rent }}
                <span class="dec">/日租价</span>
              </p>
            </div>
          </van-col>
        </van-row>

        <van-row class="order_info">
          <van-col span="24" class="info_title">订单信息</van-col>
          <van-col span="24" class="member_info info1">
            订单金额：￥{{ detailInfo.deposit_amount }}
          </van-col>
          <van-col span="24" class="member_info">
            尾款金额：￥{{ detailInfo.balance_rent }}
          </van-col>
          <van-col span="24" class="member_info">
            首年保险：￥{{ detailInfo.insurance_amount }}
          </van-col>
          <van-col span="24" class="member_info">
            预计赠送红包：<span class="coin">￥{{ refundCoin }}</span>
          </van-col>
          <van-col span="24" class="member_info">
            订单编号：<span ref="copytxt">{{ detailInfo.order_num }}</span>
            <img
              class="copy"
              src="../../assets/carRent/copy@2x.png"
              @click="copyCode"
            />
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="footer">
      实付款 <span class="label_">￥</span><span>{{ payNum }}</span>
      <btn
        class="pay_btn"
        :btntext="'支付'"
        :btnwidth="'10.8rem'"
        :height="'4.8rem'"
        :bgcolor="'linear-gradient(to right, #49A6FF, #236DFE)'"
        :borderradius="'0.6rem'"
        :btncolor="'#fff'"
        :fontsize="'1.6rem'"
        :fontweight="700"
        @btnClick="submit"
      />
    </div>
    <div class="loading" v-if="loading">
      <img src="../../assets/common/loading.gif" />
    </div>
  </div>
</template>
<script>
import navbar from "../purchaseSupplier/components/nav-bar.vue";
import btn from "../purchaseSupplier/components/button.vue";
import dsbridge from "dsbridge";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/carRent/reback@2x.png"),
      detailInfo: {},
      facility: "",
      refundCoin: "0.00",
      payNum: "0.00",
      paying: false,
      loading: false,
      client: "",
    };
  },
  created() {
    this.getInfo();
    if (!this.$route.query.from) {
      sessionStorage.setItem("pushEnter", true);
    }
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    window.setPay = this.setPay;
    this.deductionUA();
  },
  methods: {
    goBack() {
      if (this.$route.query.from) {
        this.$router.go(-1);
      } else {
        this.$router.replace("/carRent/carList");
      }
    },
    getInfo() {
      this.$api
        .post("/onorder/member/car_rental/order/detail", {
          order_num: this.$route.query.order_num,
        })
        .then((res) => {
          this.detailInfo = res;
          this.refundCoin = (
            (Number(res.balance_rent) + Number(res.deposit_amount)) /
            2
          ).toFixed(2);
          this.payNum = (
            Number(res.balance_rent) + Number(res.insurance_amount)
          ).toFixed(2);
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    copyCode() {
      const rechage_range = document.createRange();
      rechage_range.selectNode(this.$refs.copytxt);
      const rechage_selection = window.getSelection();
      if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
      rechage_selection.addRange(rechage_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      rechage_selection.removeAllRanges();
    },
    submit() {
      // 防止重复创建订单
      if (this.paying === true) {
        return;
      }
      this.loading = true;
      this.paying = true;
      if (
        this.detailInfo.balance_pay_info &&
        this.detailInfo.balance_pay_info.pay_status == 0
      ) {
        let param = {
          actual_amount: this.payNum,
          order_amount: this.payNum,
          ordersn: this.detailInfo.balance_pay_info.ordersn,
          order_type: "car_rental_balance",
        };
        if (this.facility == "ios") {
          let that = this;
          dsbridge.call("goPay", JSON.stringify(param), function (v) {
            that.setPay(v);
          });
        } else if (this.facility == "android") {
          this.params(JSON.stringify(param), JSON.stringify(param), "goPay");
        }

        this.paying = false;
        this.loading = false;
      } else {
        // 确认订单
        this.$api
          .post("/order/member/order/confirm", {
            order: {
              type: "car_rental_balance",
            },
            order_num: this.detailInfo.order_num,
          })
          .then((data) => {
            // 创建订单
            this.$api
              .post("/order/member/order/create", {
                order: {
                  type: "car_rental_balance",
                  client: this.facility == "ios" ? 11 : 10,
                  confirm: data.order.confirm,
                },
                order_num: this.detailInfo.order_num,
              })
              .then((data) => {
                let param = {
                  actual_amount: data.actual_amount,
                  order_amount: data.order_amount,
                  ordersn: data.ordersn,
                  order_type: "car_rental_balance",
                };
                if (this.facility == "ios") {
                  let that = this;
                  dsbridge.call("goPay", JSON.stringify(param), function (v) {
                    that.setPay(v);
                  });
                } else if (this.facility == "android") {
                  this.params(
                    JSON.stringify(param),
                    JSON.stringify(param),
                    "goPay"
                  );
                }
                this.paying = false;
                this.loading = false;
              })
              .catch((err) => {
                this.paying = false;
                this.loading = false;
                let keys = Object.keys(err);
                let key = keys[0];
                let message = err.message || err[key][0];
                if (message.slice(0, 10) == "timeout of") {
                  this.$toast("网络不给力，请稍候重试");
                } else {
                  this.$toast(message);
                }
                return;
              });
          })
          .catch((err) => {
            this.paying = false;
            this.loading = false;
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
            return;
          });
      }
    },
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        //支付成功
        this.$router.replace({
          path: "/carRent/paySuccess",
          query: {
            order_num: this.detailInfo.order_num,
            order_id: this.detailInfo.id,
          },
        });
      } else {
        this.getInfo();
      }
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
        this.facility = "ios";
        this.client = 11;
      } else if (/android/.test(ua)) {
        this.facility = "android";
        this.client = 10;
      }
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.car_rent_order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .car_rent_order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: rgba(0, 0, 0, 0);
    z-index: 3;
  }

  .footer {
    position: fixed;
    bottom: 0.4rem;
    left: 0;
    display: block;
    width: 100%;
    height: 7.6rem;
    line-height: 4.8rem;
    padding: 1.4rem 2.2rem 1.4rem 1.8rem;
    box-sizing: border-box;
    color: #333;
    font-size: 1.4rem;
    background: #fff;

    span {
      color: #ff4747;
      font-size: 2rem;
    }

    .label_ {
      font-size: 1.4rem;
    }

    .pay_btn {
      float: right;
    }
  }

  .all {
    padding: 10rem 0 6.8rem;
    box-sizing: border-box;
    height: 100%;
    background: url(../../assets/carRent/bg@2x.png) no-repeat top center;
    background-size: 100% 20.6rem;

    .box {
      padding: 0 1.2rem;
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .goods {
        height: auto;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 0.6rem 0 0;

        .goods_info {
          padding: 1.4rem 1.4rem 1.6rem;
          box-sizing: border-box;
          position: relative;

          img {
            position: absolute;
            top: 1.4rem;
            left: 1.4rem;
            width: 10.7rem;
            height: 8.1rem;
            border-radius: 0.6rem;
          }

          .goods_r {
            padding-left: 11.7rem;

            .name {
              font-size: 1.6rem;
              color: #000;
              font-weight: 700;
              height: 4.4rem;
              line-height: 2.2rem;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              white-space: normal;
            }

            .stock {
              height: 1.8rem;
              margin: 0.4rem 0 0.8rem;

              span {
                color: #333;
                height: 1.6rem;
                line-height: 1.6rem;
                font-size: 1rem;
                font-weight: 700;
                border: solid 1px #c8c8c8;
                border-top-left-radius: 0.4rem;
                border-bottom-right-radius: 0.4rem;
                padding: 0 0.5rem;
              }
            }

            .unit_price {
              color: #ff4747;
              font-size: 1.6rem;
              font-weight: 700;
              line-height: 2.2rem;

              .label_ {
                font-size: 1rem;
              }

              .dec {
                color: #999;
                font-size: 1rem;
              }
            }
          }
        }
      }

      .order_info {
        padding: 1.6rem;
        background: #fff;
        border-radius: 1rem;
        margin-top: 1.2rem;

        .info_title {
          color: #000;
          font-size: 1.6rem;
          font-weight: 700;
          height: 2.2rem;
          line-height: 2.2rem;
        }

        .car_info {
          background: #f7f9fb;
          border: solid 1px #efefef;
          border-radius: 0.4rem;
          padding: 1.6rem;
          counter-reset: #333;
          font-size: 1.4rem;
          line-height: 2rem;
          margin-top: 0.8rem;
        }

        .member_info {
          margin-top: 1.2rem;
          height: 2rem;
          line-height: 2rem;
          color: #333;
          font-size: 1.4rem;

          .copy {
            width: 2rem;
            margin-left: 1rem;
            vertical-align: middle;
          }

          .coin {
            color: #ff4747;
          }
        }

        .info1 {
          margin-top: 1.6rem;
        }
      }
    }
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }
}
</style>




